import moment from 'moment';
import storage from "./storage";
import Vue from "vue"; //导入文件
const DATE_FORMAT = 'YYYY-MM-DD';
const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const TIME = 'HH:mm'; // <input type="time" />
const TIME_SECONDS = 'HH:mm:ss'; // <input type="time" step="1" />
const TIME_MS = 'HH:mm:ss.SSS'; // <input type="time" step="0.001" />

const Date = {

    numFilter(value) {
        let realVal = '';
        if (value !== '') {
            let tempVal = parseFloat(value).toFixed(3);
            realVal = tempVal.substring(0, tempVal.length - 1);
        } else {
            realVal = '--';
        }
        return realVal;
    },
    /**
     * 全项目统一上海时区（Asia/Shanghai）。
     * 历史上前后端走 UTC 双向转换，已废弃；后端 Jackson / MySQL
     * 全部以上海时区写出，前端不再做 .utc() / .local() 偏移。
     * 方法名保留 (getUTC* / getUtc*) 以避免大规模重命名，
     * 但语义已统一为「当前上海时间」。
     * 详见 docs/踩坑/IM-WebSocket-时区不对称-token查不到.md。
     */
    getUTCDateString() {
        return moment().format(DATETIME_FORMAT);
    },
    getUtcDate() {
        return moment();
    },
    getLocalDate() {
        return moment();
    },
    formatDate(date) {
        return date.format(DATE_FORMAT);
    },
    formatDateTime(date) {
        return date.format(DATETIME_FORMAT);
    },
    formatTime(date) {
        return date.format(TIME);
    },
    createDate(dateString) {
        return moment(dateString, DATETIME_FORMAT);
    },
    /**
     * 时间戳（epoch ms），与时区无关，等价于 Date.now()。
     */
    getUtcTick() {
        return moment().valueOf();
    },
    /**
     * 获取时间轴
     * @param {Object} date
     */
    getTick(date) {
        return date.valueOf();
    },
    /**
     * 已废弃：全项目统一上海时区后，前端不再做时区偏移计算。
     * 返回 0 让历史 `add(getZone(), 'h')` 调用退化为 no-op。
     */
    getZone() {
        return 0;
    },

    /**
     * 服务端时间字符串归一化为 DATETIME_FORMAT。
     * Storage.get('zone') 分支保留以兼容历史持久化数据，正常应为 0 / undefined。
     */
    getZHdate(data) {
        const offset = Number(storage.get('zone')) || 0;
        return moment(data).add(offset, 'h').format(DATETIME_FORMAT);
    },
    getDateByTimestamp(timestamp) {
        return moment(timestamp);
    },
    /**
     * 将本地时间转换成
     * @param timestamp
     */
    getBeginDateByTimestamp(timestamp) {
        return this.convert2UTCDateString(this.getDateBegin(moment(timestamp)));
    },
    /**
     * 将本地时间转换成
     * @param timestamp
     */
    getEndDateByTimestamp(timestamp) {
        return this.convert2UTCDateString(this.getDateEnd(moment(timestamp)));
    },
    /**
     * 获取date对应的当天的开始时间
     * @param date
     * @returns
     */
    getDateBegin(date) {
        return moment(date.format(DATE_FORMAT), DATETIME_FORMAT);
    },
    /**
     * 获取date对应的当天结束时间
     * @param date
     * @returns
     */
    getDateEnd(date) {
        return moment(date.add(1, 'd').format(DATE_FORMAT), DATETIME_FORMAT);
    },
    /**
     * 将给定的日期对象增加指定数量的天数
     * @param {Date|String|moment} date - 要操作的日期
     * @param {Number} days - 要增加的天数
     * @returns {moment} 返回一个新的 Moment 对象
     */
    addDays(date, days) {
        return moment(date).add(days, 'days');
    },

    /**
     * 将给定的日期对象增加指定数量的星期
     * @param {Date|String|moment} date - 要操作的日期
     * @param {Number} weeks - 要增加的星期数
     * @returns {moment} 返回一个新的 Moment 对象
     */
    addWeeks(date, weeks) {
        return moment(date).add(weeks, 'weeks');
    },

    /**
     * 将给定的日期对象增加指定数量的月份
     * @param {Date|String|moment} date - 要操作的日期
     * @param {Number} months - 要增加的月份数
     * @returns {moment} 返回一个新的 Moment 对象
     */
    addMonths(date, months) {
        return moment(date).add(months, 'months');
    },

    /**
     * 将给定的日期对象增加指定数量的年份
     * @param {Date|String|moment} date - 要操作的日期
     * @param {Number} years - 要增加的年份数
     * @returns {moment} 返回一个新的 Moment 对象
     */
    addYears(date, years) {
        return moment(date).add(years, 'years');
    },
    /**
     * 历史方法：原用于把本地时间转 UTC 上送服务端。
     * 现在前后端都用上海时区，直接原样格式化返回。
     */
    convert2UTCDateString(date) {
        return moment(date).format(DATETIME_FORMAT);
    },
    /**
     * 历史方法：原用于把 UTC 字符串转本地时间。现已不做偏移。
     */
    convert2LocalTimeString(dateString) {
        return this.createDate(dateString).format(TIME);
    },
    /**
     * @param {String} dateString 历史方法：原用于把 UTC 字符串转本地。
     * 现在服务端返回的就是上海时间，直接格式化即可。
     */
    convert2LocalDate(dateString, format = DATETIME_FORMAT) {
        return moment(dateString, DATETIME_FORMAT).format(format);
    },
    getOrder(data) {
        return moment(data).format('YY.MM.DD')
    },
    getInternationalTime(data) {
        return moment(data).format('x');
    }
};


export default Vue.prototype.$DateUtil = Date
